export var CardAction = /*#__PURE__*/function (CardAction) {
  CardAction["DownloadAction"] = "DownloadAction";
  CardAction["PreviewAction"] = "PreviewAction";
  CardAction["ViewAction"] = "ViewAction";
  CardAction["ChangeStatusAction"] = "ChangeStatusAction";
  CardAction["FollowAction"] = "FollowAction";
  CardAction["CopyLinkAction"] = "CopyLinkAction";
  CardAction["AISummaryAction"] = "AISummaryAction";
  CardAction["AutomationAction"] = "AutomationAction";
  return CardAction;
}({});